import { Trans } from "@lingui/react/macro";
import { Navigate, NavLink, Route, Routes } from "react-router-dom";
import { AdminAuditPage } from "./audit-page";
import { AdminCompanyModelsPage } from "./company-models-page";
import { AdminKnowledgePage } from "./knowledge-page";
import { AdminTemplateDetailPage } from "./template-detail-page";
import { AdminTemplatesListPage } from "./templates-page";
import { AdminUsersPage } from "./users-page";

const TAB =
  "rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground hover:text-foreground aria-[current=page]:bg-muted aria-[current=page]:text-foreground";

/** The IT admin area: a tab bar over the Users, Templates and Audit log pages. */
export function AdminPage() {
  return (
    <div className="h-full overflow-y-auto bg-background" data-testid="admin-page">
      <div className="mx-auto w-full max-w-5xl px-4 py-6">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
          <h1 className="text-lg font-semibold">
            <Trans>Admin</Trans>
          </h1>
          <NavLink to="/app" className="text-sm text-muted-foreground hover:text-foreground">
            <Trans>Back to chat</Trans>
          </NavLink>
        </div>
        <nav className="mb-6 flex flex-wrap gap-1 border-b border-border pb-2">
          <NavLink to="/admin/users" className={TAB}>
            <Trans>Users</Trans>
          </NavLink>
          <NavLink to="/admin/templates" className={TAB}>
            <Trans>Templates</Trans>
          </NavLink>
          <NavLink to="/admin/company-models" className={TAB}>
            <Trans>Company models</Trans>
          </NavLink>
          <NavLink to="/admin/knowledge" className={TAB}>
            <Trans>Knowledge</Trans>
          </NavLink>
          <NavLink to="/admin/audit" className={TAB}>
            <Trans>Audit log</Trans>
          </NavLink>
        </nav>
        <Routes>
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="templates" element={<AdminTemplatesListPage />} />
          <Route path="templates/:templateId" element={<AdminTemplateDetailPage />} />
          <Route path="company-models" element={<AdminCompanyModelsPage />} />
          <Route path="knowledge" element={<AdminKnowledgePage />} />
          <Route path="knowledge/:collectionId" element={<AdminKnowledgePage />} />
          <Route path="audit" element={<AdminAuditPage />} />
          <Route path="*" element={<Navigate to="/admin/users" replace />} />
        </Routes>
      </div>
    </div>
  );
}
